import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXYogurt = () => (
  <ArticleWrapper articleId="hmx_yogurt">
    <div className="prose prose-invert mx-auto p-6">
      <h1>HMX Yogurt</h1>
      {/* Add your HMX Yogurt article content here */}
      <p>This is a placeholder article for the HMX Yogurt switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default HMXYogurt;
